/** One way to go from an open task: what it opens (for the hint) and how. Null: nothing that way. */
export type TaskStep = { label: string; onSelect: () => void } | null;

/** SF-T-236: the tasks either side of the open one in the list it was opened from (the Inbox). */
export type TaskSteps = { previous: TaskStep; next: TaskStep };

/** The keys that step (the Inbox's stepKey), named in the arrows' hints. */
export const TASK_STEP_KEYS = { previous: 'K', next: 'J' } as const;

/** Marks the desktop arrows, so a click on them isn't a click outside the pop-up (TaskPopup). */
export const TASK_STEP_ATTR = 'data-task-step';
